import { Link, Typography } from '@material-ui/core';
import { Stack } from '@superdispatch/ui';
import { Box, Button } from '@superdispatch/ui-lab';
import { isWebView } from 'shared/constants/AppTypeConstants';
import { useCustomerSupport } from 'shared/helpers/CustomerSupport';
import { InstantTransferDescription } from 'shared/modules/superpay/instant-transfer/InstantTransferDescription';
import styled from 'styled-components';

const BoxStyled = styled(Box)`
  flex-direction: column;
  gap: 24px;
`;

export function InstantTransferSomethingWentWrong({
  onClose,
}: {
  onClose: () => void;
}) {
  const { showLauncherMessanger } = useCustomerSupport();

  return (
    <BoxStyled
      padding="medium"
      height="100%"
      display="flex"
      justifyContent="space-between"
      alignItems="flex-end"
    >
      <Stack space="medium">
        <Stack space="small">
          <Typography variant="h2">Something went wrong.</Typography>
          <Stack>
            <Typography>Please try again or come back later.</Typography>
            <Link
              component="button"
              color="textPrimary"
              onClick={() => {
                showLauncherMessanger();
              }}
            >
              Contact Support
            </Link>
          </Stack>
        </Stack>
        <InstantTransferDescription />
      </Stack>
      <Button fullWidth={isWebView} onClick={onClose}>
        Got It
      </Button>
    </BoxStyled>
  );
}
